<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>皮肤宝箱配置</span>
          <clear-cache-apply />
          <sync-data />
        </div>

        <el-table
          :data="formData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
          >
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.id" placeholder="宝箱ID" />
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="宝箱名称"
          >
            <template v-slot:default="scope">
              <el-input v-model="scope.row.name" style="width: 150px;" placeholder="宝箱名称" />
            </template>
          </el-table-column>
          <el-table-column
            prop="skinResourceId"
            label="皮肤资源ID"
          >
            <template v-slot:default="scope">
              <el-input v-model="scope.row.skinResourceId" placeholder="皮肤资源ID" />
            </template>
          </el-table-column>
          <el-table-column
            label="卡片数量"
          >
            <template v-slot:default="scope">
              <el-input v-model="scope.row.reward[0].num" placeholder="卡片数量" />
            </template>
          </el-table-column>
          <el-table-column
            label="小丑卡兑换数量"
          >
            <template v-slot:default="scope">
              <el-input v-model="scope.row.reward[1].num" placeholder="体力奖励" />
            </template>
          </el-table-column>
          <el-table-column
            label="小丑卡兑换数量"
          >
            <template v-slot:default="scope">
              <el-input v-model="scope.row.reward[1].num" placeholder="体力奖励" />
            </template>
          </el-table-column>
          <el-table-column
            label="小丑卡兑换数量"
          >
            <template v-slot:default="scope">
              <el-input v-model="scope.row.reward[1].num" placeholder="体力奖励" />
            </template>
          </el-table-column>
          <el-table-column
            label="配置"
          >
            <template v-slot:default="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="langVisibleArr[scope.$index].visible = true" />
              <el-dialog :before-close="(d)=>{return handleClose(d, scope.$index)}" style="overflow-y: auto" title="配置" width="1800px" :visible="langVisibleArr[scope.$index].visible" @open="openWeight(scope.$index,2)">
                <el-row :gutter="10" class="mb8" style="margin-top: 10px;">
                  <el-col :span="1.5">
                    <el-upload
                      :ref="'upload'+scope.$index"
                      class="upload-demo"
                      :action="sys_app_logoAction"
                      accept="xlsx"
                      :limit="1"
                      :on-success="(res)=>{return importUploadSuccess(res, scope.row.id, scope.$index,2)}"
                      :headers="headers"
                    >
                      <el-button v-permisaction="['config:chestSkin:import']" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
                    </el-upload>
                  </el-col>

                  <el-col :span="1.5">
                    <el-button
                      v-permisaction="['config:chestSkin:export']"
                      type="primary"
                      icon="el-icon-download"
                      size="mini"
                      @click="exportData(scope.row.id)"
                    >导出</el-button>
                  </el-col>
                </el-row>

                <el-tabs v-model="activeName" @tab-click="(tab, event)=>handleClick(tab, event, scope.$index)">
                  <el-tab-pane v-for="(item, index) in typeTable" :key="index" :label="item.label" :name="item.value">
                    <el-form>
                      <el-table :data="weightData" border stripe>
                        <el-table-column prop="lv" label="等级">
                          <template v-slot:default="scope">
                            <span>{{ scope.row.lv }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column v-for="(item, index) in weightNumber" :key="index" :label="'权重'+item">
                          <template v-slot:default="scope">
                            <span>{{ scope.row.weight[index].num }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-form>
                  </el-tab-pane>
                </el-tabs>
                <div slot="footer" class="dialog-footer">
                  <!--                  <el-button @click="langVisibleArr[index].visible = false">取 消</el-button>-->
                  <el-button type="primary" @click="langVisibleArr[scope.$index].visible = false">确 定</el-button>
                </div>
              </el-dialog>

            </template>
          </el-table-column>
          <el-table-column
            label="概率配置"
          >
            <template v-slot:default="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="starProVisibleArr[scope.$index].visible = true" />
              <el-dialog :before-close="(d)=>{return handleClose(d, scope.$index)}" style="overflow-y: auto" title="概率配置" width="500px" :visible="starProVisibleArr[scope.$index].visible">
                <el-form>
                  <el-row v-for="(r,i) in scope.row.starPro.pro" :key="i">
                    <el-form-item :label="i+1+'概率'" style="margin-top: 10px;">
                      <el-input v-model.number="r.v" style="width: 130px;" placeholder="概率" />
                    </el-form-item>
                  </el-row>
                  <el-form-item label="金卡数量(-1,不设限制" style="margin-top: 10px;">
                    <el-input v-model.number="scope.row.starPro.maxGoldCard" style="width: 130px;" placeholder="金卡数量" />
                  </el-form-item>
                  <el-form-item label="卡片类型" style="margin-top: 10px;">
                    <el-select v-model.number="scope.row.starPro.cardType" placeholder="请选择">
                      <el-option v-for="item in cardType" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="保底星级" style="margin-top: 10px;">
                    <el-select v-model.number="scope.row.starPro.guaranteed" placeholder="请选择">
                      <el-option v-for="item in guaranteedSelect" :key="item.star" :label="item.star+' 星级'" :value="item.star" />
                    </el-select>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="starProVisibleArr[scope.$index].visible = false">取 消</el-button>
                  <el-button type="primary" @click="starProSave(scope.$index)">确 定</el-button>
                </div>
              </el-dialog>

            </template>
          </el-table-column>
        </el-table>

        <el-button v-permisaction="['config:chestSkin:add']" size="mini" type="primary" @click="add()">+</el-button>
        <el-button v-permisaction="['config:chestSkin:add']" size="mini" type="primary" @click="onSubmit()">保存</el-button>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import {
  exportChestWeight,
  getChestCfgList,
  importChestWeight,
  updateChestCfg
} from '@/api/config/chest-skin-cfg'
import { getToken } from '@/utils/auth'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'ChestSkin',
  components: { SyncData, ClearCacheApply },
  data() {
    return {
      activeName: 'money',
      typeTable: [{ label: '金币', value: 'money' }, { label: '体力', value: 'spins' }, { label: '钻石', value: 'diamond' }],
      langVisibleArr: [{ visible: false }],
      weightVisibleArr: [{ visible: false }],
      starProVisibleArr: [{ visible: false }],
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 100
      },
      cardType: [{ label: '常规卡片', value: 0 }, { label: '限时卡片', value: 1 }],
      weightNumber: {},
      weightData: [],
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      guaranteedSelect: [
        { star: 0, v: 30 },
        { star: 1, v: 30 },
        { star: 2, v: 60 },
        { star: 3, v: 80 },
        { star: 4, v: 90 },
        { star: 5, v: 30 }
      ],
      formData: [
        {
          'id': 0,
          'name': '',
          'skinResourceId': 0,
          'reward': [
            { num: 0, propsId: 0 },
            { num: 0, propsId: 0 },
            { num: 0, propsId: 14 },
            { propsId: 15, pro: [] },
            { propsId: 8, pro: [] }
          ],
          starPro: {
            pro: [
              { star: 1, v: 30 },
              { star: 2, v: 60 },
              { star: 3, v: 80 },
              { star: 4, v: 90 },
              { star: 5, v: 30 }
            ],
            maxGoldCard: 2,
            cardType: 0,
            guaranteed: 0
          }
        }
      ],
      weightFormData: {
        'propsId': 0,
        'name': '',
        'reward': [
          {
            num: 0,
            propsId: 17
          }, {
            num: 0,
            propsId: 18
          }, {
            pro: [{
              num: 0,
              v: 0
            }],
            propsId: 14
          }, {
            propsId: 15,
            pro: []
          }, {
            propsId: 8,
            pro: []
          }]
      }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    handleClose(d, index) {
      // this.langVisibleArr[index].visible = false
    },
    handleWeightClose(d, index) {
      // this.weightVisibleArr[index].visible = false
    },
    onSubmit() {
      for (const i in this.formData) {
        const _data = this.formData[i]
        if (_data.name === '') {
          this.msgError('宝箱名称不能为空')
          return false
        }
      }
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateChestCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.$store.dispatch('app/clearLocalStorage', { key: 'getChestCfgAll' })
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getChestCfgList(this.queryParams).then(res => {
        res.data.list.forEach((item, index) => {
          this.langVisibleArr.push({
            visible: false
          })
          this.weightVisibleArr.push({
            visible: false
          })
          this.starProVisibleArr.push({
            visible: false
          })
        })
        this.formData = res.data.list
        this.total = res.data.count
      })
    },
    addReward(index) {
      this.formData[index].reward[2].pro.push({
        num: 1,
        v: 0
      })
    },
    removeReward(index, zIndex) {
      this.formData[index].reward[2].pro = this.formData[index].reward[2].pro.filter((item, i) => {
        return i !== zIndex
      })
    },
    openWeight(index, key, opened = true) {
      if (opened) {
        this.activeName = 'money'
      }
      this.weightNumber = []
      // console.log('this.formData', this.formData[index].reward[key])
      this.weightData = this.formData[index].reward[key].pro
      if (!this.weightData) {
        this.weightData = []
        return
      }
      if (this.weightData.length > 0) {
        const len = this.weightData[0].weight.length
        for (let i = 0; i < len; i++) {
          this.weightNumber[i] = this.weightData[0].weight[i].v
        }
      }
    },
    exportData(id) {
      exportChestWeight({ id: id }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importUploadSuccess(response, id, index, key) {
      if (this.$refs['upload' + index][0]) {
        this.$refs['upload' + index][0].clearFiles()
      } else {
        this.$refs['upload' + index].clearFiles()
      }
      importChestWeight({ data: response.data.path, name: id, type: key }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
          setTimeout(() => {
            this.openWeight(index, key)
          }, 800)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    starProSave(index) {
      this.starProVisibleArr[index].visible = false
      this.onSubmit()
    },
    add() {
      this.formData.push({
        propsId: 0,
        name: '',
        skinResourceId: 0,
        reward: [
          {
            num: 0,
            propsId: 17
          }, {
            num: 0,
            propsId: 18
          },
          {
            num: 1,
            propsId: 14,
            pro: []
          }, {
            propsId: 15,
            pro: []
          }, {
            propsId: 22,
            pro: []
          }],
        starPro: {
          pro: [
            { star: 1, v: 30 },
            { star: 2, v: 60 },
            { star: 3, v: 80 },
            { star: 4, v: 90 },
            { star: 5, v: 30 }
          ],
          maxGoldCard: 2
        }
      })

      this.langVisibleArr.push({
        visible: false
      })
      this.weightVisibleArr.push({
        visible: false
      })
      this.starProVisibleArr.push({
        visible: false
      })
    },
    handleClick(tab, event, key) {
      const index = parseInt(tab.index) + 2
      this.openWeight(key, index, false)
    }
  }
}
</script>

<style scoped>
table {
  border-collapse: collapse; /* 合并边框 */
}

td {
  border: 1px solid #ccc; /* 单元格边框样式 */
  padding: 5px; /* 单元格内边距 */
  height: 30px;
  width: 100px;
  text-align: center;
}
</style>
